module.exports = __webpack_public_path__ + "img/level_txt_1.9c20b342.png";